import {injectable} from 'inversify'
import type {AnalyticService} from '@/src/ports/services/analytic-service'
import values from 'lodash/values'
import {BasketData} from '@/src/entities/basket'

@injectable()
export class MindboxAnalytics {
  constructor(private analyticService: AnalyticService) {}

  viewProduct(id: Id) {
    this.analyticService.track('Website.ViewProduct', {
      viewProduct: {
        product: {
          ids: {
            website: id,
          },
        },
      },
    })
  }

  viewCategory(id: Id) {
    this.analyticService.track('Website.ViewCategory', {
      viewProductCategory: {
        productCategory: {
          ids: {
            website: id,
          },
        },
      },
    })
  }

  setBasket(basket: BasketData) {
    this.analyticService.track('Website.SetCart', {
      productList: values(basket.lines).map(basketItem => ({
        count: basketItem.quantity,
        // pricePerItem: basketItem.discount_price,
        priceOfLine: basketItem.discount_total,
        product: {
          ids: {
            website: basketItem.variant_id ?? basketItem.product_id,
          },
        },
      })),
    })
  }
}
